import   React                            ,
       { useState                         ,
         useEffect                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./UserLogin.module.scss";


import { convertDateToString              ,
         convertStringToDate                   }  from '../../../dataTypes/timeManagment/utils';

import { groupData                }  from "../../../dataTypes/dataSetManagment/regroupData";

import   TabularDisplay                      from "../../widget/dataDisplay/tables/TabularDisplay";
import   Select                              from '../../widget/inputs/Select';
import   Field                               from '../../widget/inputs/Field';

import { UserAuthenticationResult         }  from '../../../dataTypes/userManagment/types';



import { getUserAuthenticationResultList  }  from '../../../backendServices/userManagment/api';


interface UserLoginProps {
  userId?: number; // facultatif
  userSubscriptionDate?: Date
}

export const UserLogin: React.FC<UserLoginProps> = ({ userId , userSubscriptionDate }) => {
  const periodNames: string[] = ["Jour courant", "Semaine courante", "Mois courant", "Personnaliser"]

  const now = new Date();

  // 7 jours glissants (le jour courant étant le dernier jour)
  const rollingWeekStart   = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6, 0, 0, 0);
  const rollingWeekEnd     = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

  // Mois courant
  const currentDayStart    = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const currentDayEnd      = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

  // Mois courant
  const currentMonthStart  = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
  const currentMonthEnd    = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

  // Mois précédent

  // Année courante (du 1er janvier jusqu'à aujourd'hui)

  // Année précédente (du 1er janvier au 31 décembre)

  const [                       , setShowWaitingIcon                      ] = useState(false);

  const [ selectedLoginPeriod                  , setSelectedLoginPeriod                  ] = useState (periodNames[0])
  const [              , setSelectedLoginPeriodIndex             ] = useState (0)
  const [ loginPeriodStartDate                 , setLoginPeriodStartDate                 ] = useState<Date> ( rollingWeekStart );
  const [ loginPeriodEndDate                   , setLoginPeriodEndDate                   ] = useState<Date> ( rollingWeekEnd );
  const [ logins                               , setLogins                               ] = useState<UserAuthenticationResult[]> ( [] )

  const fetchLoginInfos = async () => {
    try
     {
      const [
        getUserAuthenticationResultListResponse
      ] = await Promise.all([
        getUserAuthenticationResultList(loginPeriodStartDate, loginPeriodEndDate, userId)
      ]);

      console.log (getUserAuthenticationResultListResponse)

      if (getUserAuthenticationResultListResponse.code === 1)
            {
             const logins = getUserAuthenticationResultListResponse.payload;

             const sortedLogins = logins.sort((a, b) => {
                                                         const dateA = a.date ? a.date.getTime() : 0;
                                                         const dateB = b.date ? b.date.getTime() : 0;
                                                         return dateB - dateA;
                                                        });

             console.log ( sortedLogins)

             setLogins(sortedLogins);
            }
       else {
             setLogins([]);
            }

     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
    finally
     {
      setShowWaitingIcon(false);
     }
  };

  useEffect(() => {
    fetchLoginInfos();
  }, [loginPeriodStartDate,  loginPeriodEndDate]);

  const handleLoginPeriodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
	  
	console.log ('handleLoginPeriodChange', e.target.value)
	  
    setSelectedLoginPeriod      (e.target.value);
    setSelectedLoginPeriodIndex (e.target.selectedIndex);

    switch ( e.target.selectedIndex )
     {
      case 0 : // Jour courant

               setLoginPeriodStartDate(currentDayStart);
               setLoginPeriodEndDate(currentDayEnd);
               break;
      case 1 : // Semaine courante

               setLoginPeriodStartDate(rollingWeekStart);
               setLoginPeriodEndDate(rollingWeekEnd);
               break;

      case 2 : // Mois courant

               setLoginPeriodStartDate(currentMonthStart);
               setLoginPeriodEndDate(currentMonthEnd);
               break;

     }
  };

  const handleLoginPeriodStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate, "dd/MM/yyyy")

    if (convertedDate)
          {
           setLoginPeriodStartDate(convertedDate);
          }
     else {
           console.error("Invalid date format received");
          }
  }

  const handleLoginPeriodEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate, "dd/MM/yyyy");

    if (convertedDate)
          {
           setLoginPeriodEndDate(convertedDate);
          }
     else {
           console.error("Invalid date format received");
          }
  }




  let groupKeyLogin = (login: UserAuthenticationResult) => ({
                                                              key      : `${convertDateToString(login.date,"yyyy")}`,
                                                              renderer : (val: string) => val,
                                                           })

  const groupedLogins = groupData<UserAuthenticationResult> ( logins, groupKeyLogin );

  console.log ( groupedLogins )

  const columns = [
    {
      header: 'Date',
      accessor: 'date' as keyof UserAuthenticationResult,
      width: '150px',
//      cellRenderer: (value: Date) => ( <span> {convertDateToString (value , 'dd/MM/yyyy HH:mm:ss' ) } </span> ),
      cellRenderer : (value: Date) => ( <span> {value.toLocaleString()} </span> ),
    },
    {
      header: 'État',
      accessor: 'status' as keyof UserAuthenticationResult,
      cellRenderer: (value: string) => ( <span className={value !== 'Succès' ? styles.locked : ''}> {value === 'Succès' ? 'Succès' : 'Echec'} </span> ),
      width: '90px'
    },
    {
      header: 'Adresse IP',
      accessor: 'ipAddress' as keyof UserAuthenticationResult,
      cellRenderer: (value: string) => ( <span> {value} </span> ),
      width: '90px'
    },
    {
      header: 'FAI',
      accessor: 'isp' as keyof UserAuthenticationResult,
      cellRenderer: (value: string) => ( <span> {value} </span> ),
      width: '300px'
    },
    {
      header: 'Ville',
      accessor: 'city' as keyof UserAuthenticationResult,
      cellRenderer: (value: string) => ( <span> {value} </span> ),
      width: '200px'
    },
 //   { header: 'ID', accessor: 'id' as keyof UserAuthenticationResult, width: '50px'},
 //   { header: 'Email', accessor: 'email' as keyof UserAuthenticationResult },
  ];

  const renderLastLogin = (): JSX.Element => {
    return (
	   <>
        <div className={classNames(styles.loginPeriodChoice)}>
          <Select choices  = {periodNames}
                  value    = {selectedLoginPeriod}
                  onChange = {handleLoginPeriodChange} />
          {
           selectedLoginPeriod === periodNames[3] &&
           <div className={classNames(styles.loginPeriodChoice2)}>
             <Field value     = {loginPeriodStartDate ? convertDateToString (loginPeriodStartDate, "dd/MM/yyyy") : ''}
                    onChange  = {handleLoginPeriodStartDateChange}
                    type      = "calendar"  />
             <Field value     = {loginPeriodEndDate ? convertDateToString (loginPeriodEndDate, "dd/MM/yyyy") : ''}
                    onChange  = {handleLoginPeriodEndDateChange}
                    type      = "calendar"  />
           </div>
          }
        </div>
        <div className={styles.lastloginWrapper}>
         <div className={styles.lastloginContainer}>
		   {
            groupedLogins.groups.size > 0
            ?
            (
             <TabularDisplay groupedData           = {groupedLogins}
                          columns               = {columns}
                          defaultHighlightColor = "#4421AA"
                          showGroupHeaders      = {false} />
            )
            :
            (
             <div className={styles.noData}>Aucune donnée pour<br/>la période considérée</div>
            )
           }
          
         </div>
        </div>
	   </>	
    );
  };

  return (
      <div className={classNames(styles.lastlogin)}>
        {renderLastLogin()}
      </div>
  );
};

export default UserLogin;